export enum ItemActionEnum {
  LoadItems = 'LoadItems',
  LoadItem = 'LoadItem',
  Table = 'Table',
  SelectedItem = 'SelectedItem',
  SelectionChanged = 'SelectionChanged',
  View = 'View',
  Add = 'Add',
  Edit = 'Edit',
  Save = 'Save',
  Cancel = 'Cancel',
  CancelEdit = 'CancelEdit',
  Delete = 'Delete',
  Copy = 'Copy',
  Import = 'Import',
  ImportGxtPrint = 'ImportGxtPrint',
  Export = 'Export',
  Accept = 'Accept',
  Storniraj = 'Storniraj',
  Edited = 'Edited',
  Added = 'Added',
  Deleted = 'Deleted',
  FilterItemChanged = 'FilterItemChanged',
  EditingCellStart = 'EditingCellStart',
  EditingCellEnd = 'EditingCellEnd',
  Attachments = 'Attachments',
  Print = 'Print',
  TabChanged = 'TabChanged',
  Refresh = 'Refresh',
  Post = 'Post',
  LockAndPost = 'LockAndPost',
  Lock = 'Lock',
  MultiselectItems = 'MultiselectItems',
  CancelMultiselection = 'CancelMultiselection',
  DocumentStatusChanges = 'DocumentStatusChanges',
  History = 'History',
  Generate = 'Generate',
  SendNow = 'SendNow'
}
